import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TqaLogo from '../assets/tqa-logo.svg';

const LoginPage = () => {
  const { user, loading, error, loginWithGoogle } = useAuth();
  const location = useLocation();
  const fromLocation = location.state?.from;
  const redirectTo = fromLocation
    ? `${fromLocation.pathname || ''}${fromLocation.search || ''}${fromLocation.hash || ''}` || '/'
    : '/';

  if (!loading && user) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8 space-y-6 border border-gray-100">
        <div className="flex flex-col items-center space-y-3 text-center">
          <img src={TqaLogo} alt="TQA" className="h-16 w-16" />
          <h1 className="text-2xl font-semibold text-gray-900">Sign in to Project Hub</h1>
          <p className="text-gray-600">Use your Google account to access the Code Review Agent workspace.</p>
        </div>

        {error && (
          <div className="rounded-lg bg-red-50 text-red-600 px-4 py-3 text-sm border border-red-100">
            {error}
          </div>
        )}

        <button
          type="button"
          onClick={() => loginWithGoogle(redirectTo)}
          className="w-full inline-flex items-center justify-center gap-3 rounded-lg border border-gray-300 py-3 font-medium text-gray-700 hover:bg-gray-50 transition-colors duration-150"
        >
          <span className="h-5 w-5" aria-hidden="true">
            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className="h-5 w-5">
              <path fill="#4285f4" d="M507.9 208.1H260.6v98.1h141.6c-6.1 32.5-24.6 60.1-52.4 78.6v65.2H440c63.8-58.7 67.9-161.9 67.9-171.9 0-10.1-.5-20.1-2-30z" />
              <path fill="#34a853" d="M260.6 512c70 0 128.8-23.4 171.7-62.1l-82.6-64.6c-23.1 15.5-52.8 24.6-89.1 24.6-68 0-125.7-45.9-146.4-107.4H28.2v67.6C71 463.4 159.2 512 260.6 512z" />
              <path fill="#fbbc04" d="M114.2 302.5c-4.8-14.4-7.5-29.7-7.5-45.5 0-15.8 2.7-31.1 7.8-45.5V144H28.2C10.2 180.7 0 221.3 0 257c0 35.8 10.2 76.3 28.2 113l86-67.5z" />
              <path fill="#ea4335" d="M260.6 100.1c37.8 0 71.5 13 98.2 38.5l73.8-73.8C389.2 23.1 330.6 0 260.6 0 159.2 0 71 48.6 28.2 144l86.1 67.6C134.9 146 192.7 100.1 260.6 100.1z" />
            </svg>
          </span>
          Continue with Google
        </button>

        <p className="text-xs text-gray-400 text-center">
          Access is limited to authorized Google accounts. Contact the workspace administrator if you need help.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
